import React from 'react'
import { CandidateReport3 } from '../apis/entities/report.entity'
import { Assessment3 } from '../apis/entities/assessment.entity'
import ReactLoading from 'react-loading'

type AssessmentIndividualReportProps = {
  candidateId: string
  assessment: Assessment3
  data: CandidateReport3
  testDate: string
  logo: string
  showAllOutcomes: boolean
}

/** Footer rendered in-flow so it works both on screen (fixed-height page) and in print (auto-height). */
const PageFooter = () => (
  <div className="mt-auto pt-4 border-t border-black">
    <div className="font-roboto flex items-center gap-2 justify-end pt-2">
      <span>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM8.89258 8.58887C10.5675 6.59294 13.3866 6.45808 15.21 8.2959C15.5988 8.68797 15.5961 9.32103 15.2041 9.70996C14.812 10.0988 14.179 10.0961 13.79 9.7041C12.7992 8.70562 11.3471 8.77503 10.4248 9.87402C9.43819 11.0497 9.43819 12.9503 10.4248 14.126C11.3471 15.225 12.7992 15.2944 13.79 14.2959C14.179 13.9039 14.812 13.9012 15.2041 14.29C15.5961 14.679 15.5988 15.312 15.21 15.7041C13.3866 17.5419 10.5675 17.4071 8.89258 15.4111C7.28244 13.492 7.28244 10.508 8.89258 8.58887Z"
            fill="black"
          />
        </svg>
      </span>
      2026 UNSW. All rights reserved.
    </div>
  </div>
)

export default function ReportContent3({
  candidateId,
  assessment,
  data,
  testDate,
  logo,
  showAllOutcomes,
}: AssessmentIndividualReportProps) {
  return (
    <div className="report-v3-wrapper">
      {/* Page 1 */}
      <div className="report-page flex flex-col pl-2 pr-2 pt-3 pb-4">
        {data === undefined && (
          <ReactLoading
            className="self-center mt-auto mb-auto"
            type={'spinningBubbles'}
            color={'#eeeeee'}
            height={'64px'}
            width={'64px'}
          />
        )}

        {data && (
          <>
            {/* Main content — grows to fill available space before footer */}
            <div className="flex-1 text-left">
              {/* Header */}
              <div className="flex justify-between items-center gap-6">
                {/* Left: logo + title + description */}
                <div className="self-start">
                  <img src={logo} alt="logo" className="w-[300px]" />
                  <div className="text-2xl font-bold pt-7">
                    {assessment?.title}
                  </div>
                  <div className="pt-3 font-roboto pb-6">
                    {assessment?.description}
                  </div>
                </div>

                {/* Right: candidate info */}
                <div className="flex flex-col gap-3">
                  <div className="text-[32px] font-bold">
                    {data?.firstName} {data?.lastName}
                  </div>
                  <div className="text-sm font-semibold font-roboto">
                    Test date: {testDate}
                  </div>
                  <div className="text-sm font-semibold font-roboto">
                    Result code: {data?.id}
                  </div>
                </div>
              </div>
            </div>

            {/* Footer — pushed to bottom on screen; flows naturally in print */}
            <PageFooter />
          </>
        )}
      </div>
    </div>
  )
}
